import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { LoaderService } from '@shared/async-services/loader/loader.service';
import { ConfirmDialogComponent } from '@shared/confirm-dialog/confirm-dialog.component';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import { CommonService } from '@shared/services/common.service';
import storageService from '@shared/storage/storageService';
import { AddOrganizationComponent } from '../add-organization/addorganization.component';

@Component({
  selector: 'organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss'],
})
export class OrganizationComponent implements OnInit {
  data: any[];
  cols: any[];
  subscription: any;
  showSpinner: boolean = false;
  message: any;
  dialogRef: any;
  totalRecords: any;
  DEFAULT_PAGE_NO = 0;
  DEFAULT_PAGE_SIZE = 10;
  visible = true;
  selectedLanguage = "";
  isFilterEnable = false;
  
  constructor(
    private auth: ApiCall,
    public dialog: MatDialog,
    private router: Router,
    private commonService: CommonService,
    private broadCast: BroadCastServiceService,
    public translate: TranslateService) {
  }

  ngOnInit(): void {
    this.setLanguage();
    this.broadCast.sendMessage('organization');
    this.commonService.isComponent = 'superadmin_organization';
    this.getOrganisationList();
    this.getCurrentStatus();

    this.cols = [
      { field: 'organizationName', header: 'NAME', width: '25%' },
      // { field: 'organizationEmail', header: 'EMAIL_ID', width: '25%' },
      { field: 'userLimit', header: 'REMAINING_LIMIT', width: '10%' },
    ];
  }

  setLanguage() {
    this.selectedLanguage = storageService.getItem("language");
    this.translate.use(this.selectedLanguage);
  }

  canLogout() {
    try {
      this.translate.get(['CONFIRMATION.MESSAGE'])
      .subscribe(translations => {
      this.message = translations['CONFIRMATION.MESSAGE'];
      });
      history.pushState("", "", "/#/superadmin/organization");
      this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: {
          title: "Logout",
          message: this.message,
        },
      });
      return this.dialogRef.afterClosed();
    } catch (error) {
      console.error("Error while deactivating the component, ", error);
    }
  }

  getOrganisationList() {
    try {
      this.showSpinner = true;
      this.visible = false;   // Used to refresh the pagination 
      this.auth.getOrganizationByPage(this.DEFAULT_PAGE_NO, this.DEFAULT_PAGE_SIZE, "").subscribe(
        (res: any) => {
          if(res.data != null) {

            this.data = res.data.data;
            this.totalRecords = res.data.totalRecords;
          }
        },
        (error) => {
          console.error("API error, ", error);
        },
        () => {
          this.showSpinner = false;
          this.visible = true;
        }
      );
    } catch (error) {
      console.error("Error, ", error);
    }
  }

  getCurrentStatus() {
    this.subscription = this.broadCast
      .getMessage()
      .subscribe((message) => {
        if (message == "displayData") {
          //    this.isComponent=message;
          console.log("Message", message);
          this.getOrganisationList()
        }
      });
  }
  openAddOrganization() {
    this.dialog.open(AddOrganizationComponent, {
      position: { right: '0' },
      maxHeight: '100vh'
    });
  }

  refresh() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  clearFilter(event) {
    if(event.flag) {
       this.isFilterEnable = true;
    }
  }
}
